/**
 * Enumeration for types of account.
 *
 * @readonly
 * @enum {string}
 */
export const AccountTypes = Object.freeze({
    CONSUMER: 'CONSUMER',
    CUSTOMER: 'CUSTOMER',
    DORMANT: 'DORMANT',
    INSTALLER: 'INSTALLER',
    LANGUAGE: 'LANGUAGE',
    PROVIDER: 'PROVIDER',
    RESELLER: 'RESELLER',
    SYSTEM: 'SYSTEM',
    VENDOR: 'VENDOR'
})
